import styled from "styled-components";

import { useAuth } from "src/hooks/useAuth";

import Main from "src/components/core/Main";
import TermsComponent from "src/components/seller/Terms";
import { White } from "src/styles/color";

const Wrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  position: relative;
  margin: auto;
`;

const TermDetail = ({ open }) => {
  const { user } = useAuth();

  return (
    <Main sx={{ background: White }} open={open}>
      <Wrapper>
        <TermsComponent userData={user} />
      </Wrapper>
    </Main>
  );
};
export default TermDetail;
